namespace $.$$ {

	export class $shm_dashboard_app_menu extends $.$shm_dashboard_app_menu {

		dev_mode() {
			return this.$.$mol_state_arg.value( 'dev_mode' ) === 'true'
		}

		app_section() {
			return this.$.$mol_state_arg.value( 'section' ) ?? 'mentions'
		}

		page_rows() {
			return [
				this.Head(),
				this.Body(),
				this.Foot(),
			].filter( Boolean ) as readonly $mol_view[]
		}

		version_data_default() {
			// Docker build stage overwrites date in _version.json.
			return {
				version: '-',
				date: '-',
			}
		}

		version_data() {
			return this.$.$mol_error_fence(
				()=> this.$.$mol_fetch.json( '/shm/dashboard/app/_version.json', { cache: 'no-store' } ) as { version?: string, date?: string },
				()=> this.version_data_default(),
				promise => $mol_fail_hidden( promise ),
			)
		}

		version_data_version() {
			return String( this.version_data().version || this.version_data_default().version )
		}

		version_data_date() {
			return String( this.version_data().date || this.version_data_default().date )
		}

		app_menu_rows() {
			const dashboards = this.dashboard_list()
			return [
				... this.monitoring_only()
					? [
						dashboards.List_head().Controls(),
						... dashboards.dashboard_rows(),
					]
					: [ this.mentions_enabled() ? this.Mentions_link() : null ],
				this.mention_stats_enabled() ? this.Mention_stats_link() : null,
				this.wordstat_enabled() ? this.Wordstat_link() : null,
				this.agent_enabled() ? this.Agent_link() : null,
				this.dev_mode() ? this.Docs_link() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		mention_stats_arg() {
			return {
				section: 'mention_stats', dashboard: null, report: null, ba_filter_id: null,
				wordstat_task: null, wordstat_filter_id: null, mention_stats_task: null,
			}
		}

		mention_stats_current() { return this.app_section() === 'mention_stats' }

		agent_arg() {
			return {
				section: 'agent', dashboard: null, report: null, ba_filter_id: null,
				wordstat_task: null, wordstat_filter_id: null, mention_stats_task: null,
				agent_session: null,
			}
		}

		agent_current() { return this.app_section() === 'agent' }

		tools_rows() {
			return [
				this.Lights(),
				this.agent_enabled() && this.app_section() === 'mentions' ? this.Agent_toggle() : null,
			].filter( Boolean ) as readonly $mol_view[]
		}

		mentions_arg() {
			return {
				section: 'mentions',
				dashboard: null,
				report: null,
				ba_filter_id: null,
				wordstat_task: null,
				wordstat_filter_id: null,
			}
		}

		dashboard_title_current() {
			return 'Мониторинг+'
		}

		mentions_current() {
			return this.app_section() === 'mentions'
		}

		wordstat_arg() {
			return {
				section: 'wordstat',
				dashboard: null,
				report: null,
				ba_filter_id: null,
				wordstat_task: null,
				wordstat_filter_id: null,
			}
		}

		wordstat_current() {
			return this.app_section() === 'wordstat'
		}

	}

}
